/*
 * @description:
 * @author: Jason Wong
 * @since: 2019-08-09 14:12:51
 */
import axios from "axios";
import env from "@/configs/env";

function getDownloadUrl(fileUri) {
  fileUri = fileUri.replace(/\\+/g, "/").replace(/^\\+/, "/");
  return "/corpus/glossary/file/download?path=" + encodeURIComponent(fileUri);
}

function getDownloadResourceUrl(fileUri) {
  fileUri = fileUri.replace(/\\+/g, "/").replace(/^\\+/, "/");
  return "/corpus/glossary/file/download/resource?path=" + encodeURIComponent(fileUri);
}

function getWholeDownloadUrl(fileUri) {
  return `${env.apiBaseUri}${getDownloadUrl(fileUri)}`;
}

function getWholeDownloadResourceUrl(fileUri) {
  return `${env.apiBaseUri}${getDownloadResourceUrl(fileUri)}`;
}

function mockDownloadWithIframe(fileUri) {
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";

  // 监听 load 事件
  iframe.onload = () => {
    console.log("下载请求已发起");
    document.body.removeChild(iframe); // 下载完成后移除 iframe
  };

  iframe.src = fileUri;
  document.body.appendChild(iframe);
}

function download(fileUri) {
  let url = getWholeDownloadUrl(fileUri);
  mockDownloadWithIframe(url);
}

function downloadResource(fileUri) {
  let url = getWholeDownloadResourceUrl(fileUri);
  mockDownloadWithIframe(url);
}

export { getWholeDownloadUrl, download, downloadResource, getWholeDownloadResourceUrl };
